import { render, staticRenderFns } from "./selectImg.vue?vue&type=template&id=2c702072&scoped=true"
import script from "./selectImg.vue?vue&type=script&lang=js"
export * from "./selectImg.vue?vue&type=script&lang=js"
import style0 from "./selectImg.vue?vue&type=style&index=0&id=2c702072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c702072",
  null
  
)

export default component.exports